// src/store/staffSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Async thunk to fetch staff members
export const fetchStaff = createAsyncThunk('staff/fetchStaff', async () => {
  const response = await axios.get(`${API_URL}/admin`);
  return response.data;
});

// Async thunk to add a new staff member
export const addStaff = createAsyncThunk('staff/addStaff', async (staffData) => {
  const response = await axios.post(`${API_URL}/admin/register`, staffData);
  return response.data;
});

// Async thunk to update an existing staff member
export const updateStaff = createAsyncThunk('staff/updateStaff', async ({ id, staffData }) => {
  const response = await axios.put(`${API_URL}/admin/edit/${id}`, staffData);
  return response.data;
});

// Async thunk to delete a staff member
export const deleteStaff = createAsyncThunk('staff/deleteStaff', async (id) => {
  await axios.delete(`${API_URL}/admin/delete/${id}`);
  return id;
});

const adminStaffSlice = createSlice({
  name: 'adminStaff',
  initialState: {
    staff: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaff.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchStaff.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.staff = action.payload;
      })
      .addCase(fetchStaff.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(addStaff.fulfilled, (state, action) => {
        state.staff.push(action.payload);
      })
      .addCase(updateStaff.fulfilled, (state, action) => {
        const index = state.staff.findIndex((staff) => staff.id === action.payload.id);
        if (index !== -1) {
          state.staff[index] = action.payload;
        }
      })
      .addCase(deleteStaff.fulfilled, (state, action) => {
        state.staff = state.staff.filter((staff) => staff.id !== action.payload);
      });
  },
});

export default adminStaffSlice.reducer;
